module.exports = __webpack_public_path__ + "img/243.ee5451d3.png";